import { render, staticRenderFns } from "./TlnImportPage.vue?vue&type=template&id=bb985506&"
import script from "./TlnImportPage.vue?vue&type=script&lang=ts&"
export * from "./TlnImportPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb985506')) {
      api.createRecord('bb985506', component.options)
    } else {
      api.reload('bb985506', component.options)
    }
    module.hot.accept("./TlnImportPage.vue?vue&type=template&id=bb985506&", function () {
      api.rerender('bb985506', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TLN/TlnImportPage.vue"
export default component.exports